import { HorizontalRadioListData } from 'aimo-ui';
import { useHistoryStore } from 'stores/historyStore';
import { Vehicle } from 'types/generatedSchemaTypes';
import { t } from 'i18n/init';

export type ParkingTypeFilter = 'parking' | 'charging' | 'permits' | undefined;
export type HistoryTypeFilter =
  | 'receipts'
  | 'free'
  | 'failed'
  | 'billing'
  | 'other'
  | undefined;
export type PaymentFilter = 'private' | 'business' | 'invoice' | undefined;

export type ParkingHistoryFilters =
  | {
      parkingType?: ParkingTypeFilter;
      payment?: PaymentFilter;
      vehicle?: Vehicle;
    }
  | undefined;

const createFilterOptions = () => {
  const parkingTypesFilterOptions: HorizontalRadioListData<ParkingTypeFilter>[] =
    [
      { title: t('parkingHistoryFilter.filterOptions.all'), value: undefined },
      {
        title: t('parkingHistoryFilter.filterOptions.parking'),
        value: 'parking',
      },
      {
        title: t('parkingHistoryFilter.filterOptions.charging'),
        value: 'charging',
      },
    ];
  const paymentFilterOptions: HorizontalRadioListData<PaymentFilter>[] = [
    { title: t('parkingHistoryFilter.filterOptions.all'), value: undefined },
    {
      title: t('parkingHistoryFilter.filterOptions.private'),
      value: 'private',
    },
    {
      title: t('parkingHistoryFilter.filterOptions.business'),
      value: 'business',
    },
    {
      title: t('parkingHistoryFilter.filterOptions.invoice'),
      value: 'invoice',
    },
  ];
  const historyViewTypeFilters: HorizontalRadioListData<HistoryTypeFilter>[] = [
    {
      title: t('parkingHistoryFilter.historyViewTypeOptions.receipts'),
      value: 'receipts',
    },
    {
      title: t('parkingHistoryFilter.historyViewTypeOptions.free'),
      value: 'free',
    },
    {
      title: t('parkingHistoryFilter.historyViewTypeOptions.failed'),
      value: 'failed',
    },
    {
      title: t('parkingHistoryFilter.historyViewTypeOptions.billing'),
      value: 'billing',
    },
    {
      title: t('parkingHistoryFilter.historyViewTypeOptions.other'),
      value: 'other',
    },
  ];

  const prepaidPermitHistoryViewTypeFilters: HorizontalRadioListData<HistoryTypeFilter>[] =
    [
      {
        title: t('parkingHistoryFilter.historyViewTypeOptions.receipts'),
        value: 'receipts',
      },
      {
        title: t('parkingHistoryFilter.historyViewTypeOptions.billing'),
        value: 'billing',
      },
    ];

  return {
    parkingTypesFilterOptions,
    paymentFilterOptions,
    historyViewTypeFilters,
    prepaidPermitHistoryViewTypeFilters,
  };
};

const useParkingHistoryFilter = () => {
  const filter = useHistoryStore((state) => state.parkingHistoryFilter);
  const setFilter = (newValue: ParkingHistoryFilters) => {
    useHistoryStore.getState().setParkingHistoryFilter(newValue);
  };
  const clearFilter = () => {
    useHistoryStore.getState().setParkingHistoryFilter(undefined);
  };

  const isFilterActive = (
    currentFilter: ParkingHistoryFilters | undefined
  ): boolean => {
    return (
      currentFilter !== undefined &&
      (!!currentFilter.parkingType ||
        !!currentFilter.payment ||
        !!currentFilter.vehicle)
    );
  };

  const filterOptions = createFilterOptions();

  return {
    parkingType: filter?.parkingType,
    payment: filter?.payment,
    vehicle: filter?.vehicle,
    filter,
    filterActive: isFilterActive(filter),
    clearFilter,
    setFilter,
    ...filterOptions,
  };
};
export default useParkingHistoryFilter;
